'use strict';

var _ = require('lodash');
var toastr = require('toastr');
var angular = require('angular');
var GridDateReoptPreviewButtonController = function GridDateReoptPreviewButtonController($scope, $interval, $rootScope, featureToggleService, scenarioService, reoptimizationService, reoptimizationSaveService, marketDemandGridService, flightAnalysisGridService, reoptPreviewDataUtilsService, saveButtonUtilsService) {
  var gridPanel = $scope.gridPanelScope;
  var checkStatusInterval;
  $scope.data = {
    dateReopt: ''
  };
  $scope.reoptimizePreviewEnabled = featureToggleService.isEnabled('MD_PREVIEW_REOPT');
  $scope.isReoptimizeButtonShown = false;
  $scope.mdReoptPreview = true;
  function storeServiceFlightGridReoptPrevData(selectedRows) {
    if (gridPanel.gridId === 'service-flight-analysis') {
      reoptPreviewDataUtilsService.updateFlightDetails($scope.reoptPreviewData, gridPanel, selectedRows);
    }
  }
  $scope.onRowSelection = function (event, selectedRows) {
    $scope.selectedRows = selectedRows;
    $scope.determineShowingReoptButtonOnRowSelection();
    $scope.switchReoptVisibility(selectedRows);
    storeServiceFlightGridReoptPrevData(selectedRows);
  };
  function isMarketGrid() {
    return gridPanel.gridId === 'market-demand-analysis';
  }
  $scope.switchReoptVisibility = function (selectedRows) {
    var isScenarioSelected = scenarioService.isScenarioSelected();
    $scope.hasRows = selectedRows.length > 0;
    $scope.isReoptimizeButtonShown = !isMarketGrid() && ($scope.hasRows || $scope.isMdReoptSubmitted()) && !isScenarioSelected;
    $scope.mdReoptPreview = gridPanel.isDemandManagement && $scope.reoptimizePreviewEnabled;
  };
  $scope.isMdReoptSubmitted = function () {
    return reoptPreviewDataUtilsService.isMdReoptSubmitted(gridPanel.reoptPreviewData);
  };
  $scope.isReoptPrevMenuItemDisabled = function () {
    return reoptPreviewDataUtilsService.isNdReopt(gridPanel.reoptPreviewData) || $scope.isMdReoptSubmitted();
  };
  $scope.setDefaultRadioButton = function () {
    $scope.data.dateReopt = !$scope.isReoptPrevMenuItemDisabled() ? 'reoptPreview' : 'dateReopt';
  };
  $scope.determineShowingReoptButtonOnRowSelection = function () {
    if (gridPanel.reoptPreviewData.mdReopt) {
      if ($scope.selectedRows.length === 1 && gridPanel.reoptPreviewData.mdReopt.entryKey === $scope.selectedRows[0].entryKey && !gridPanel.reoptPreviewData.mdReopt.success) {
        $scope.selectedRowPreviewRequested = true;
        $scope.data.dateReopt = 'dateReopt';
      } else {
        $scope.selectedRowPreviewRequested = false;
      }
    }
  };
  $scope.checkPreviewStatusInterval = function () {
    $scope.cancelCheckStatusInterval();
    checkStatusInterval = $interval(function () {
      $scope.checkPreviewStatus();
    }, 2500);
  };
  $scope.checkPreviewStatus = function () {
    var departureDate = gridPanel.reoptPreviewData.mdReopt.date;
    var market = gridPanel.reoptPreviewData.mdReopt.market;
    reoptimizationService.getMDStatus(departureDate, market, scenarioService.getCurrentUserMDPreviewRequestName()).then(function (response) {
      var status;
      if (!_.isEmpty(response)) {
        status = response[0].status;
        if (status === 'ERROR-PROCESSING') {
          $scope.cancelCheckStatusInterval();
          showError('Error occurred during Optimization Processing for Market ' + market + ' and Departure Date:' + departureDate);
          gridPanel.reoptPreviewData.mdReopt = undefined;
          $scope.data.dateReopt = 'reoptPreview';
        } else if (status === 'FINISHED-PROCESSING') {
          toastr.success('Reopt preview finished processing');
          $scope.cancelCheckStatusInterval();
          gridPanel.reoptPreviewData.mdReopt.success = true;
        }
      }
    });
  };
  $scope.checkStatus = function () {
    $scope.setDefaultRadioButton();
    if (gridPanel.reoptPreviewData.mdReopt && !gridPanel.reoptPreviewData.mdReopt.success) {
      $scope.checkPreviewStatusInterval();
    }
  };
  $scope.reoptimizeMarketGrid = function () {
    reoptimizationService.reoptimizeFromMarketScreen($scope.selectedRows, scenarioService.getSelectedScenarioName());
  };
  function getFlightAndMarketUserOverrides(scenarioName) {
    var previewEnabled = reoptPreviewDataUtilsService.isMdReoptPreview(gridPanel.reoptPreviewData);
    var gridsData = [{
      data: saveButtonUtilsService.getEditedRows(gridPanel.jqxGridSettings),
      gridId: gridPanel.gridId,
      selectedRows: $scope.selectedRows,
      scenarioName: scenarioName,
      previewEnabled: previewEnabled,
      userAction: 'reoptPreview'
    }];
    _.forEach(gridPanel.reoptPreviewData.flightDetails, function (detail) {
      gridsData.push({
        data: saveButtonUtilsService.getEditedRowsFromData(detail.loadedData),
        gridId: detail.gridId,
        selectedRows: detail.selectedRows,
        scenarioName: scenarioName,
        previewEnabled: previewEnabled,
        userAction: 'reoptPreview'
      });
    });
    return gridsData;
  }
  function submitMDReoptPreview() {
    var scenarioName = scenarioService.MDPreviewRequest;
    var saveDataArray = getFlightAndMarketUserOverrides(scenarioName);
    reoptPreviewDataUtilsService.initMdReopt(gridPanel.reoptPreviewData, $scope.selectedRows[0], $scope.demandManagementData.legDateSelected);
    $scope.data.dateReopt = 'dateReopt';
    toastr.success('Submitting date reopt preview request');
    reoptimizationSaveService.saveDataBeforeReoptPrev(saveDataArray, scenarioName).then(function () {
      reoptimizationService.reoptimizeMD($scope.selectedRows, scenarioService.MDPreviewRequest, true);
    }).then(function () {
      $scope.checkPreviewStatusInterval();
    });
  }
  $scope.submitReopt = function () {
    if ($scope.selectedRows.length) {
      if ($scope.data.dateReopt === 'dateReopt') {
        $scope.reoptimizeMarketGrid();
      } else if ($scope.data.dateReopt === 'reoptPreview') {
        return submitMDReoptPreview();
      }
    }
  };
  function showError(message) {
    toastr.error(message);
  }
  function updateReoptPreviewRows() {
    if (reoptPreviewDataUtilsService.isMdReoptPreview(gridPanel.reoptPreviewData)) {
      marketDemandGridService.updateReoptPreviewRows(gridPanel.gridId, gridPanel.jqxGridSettings, gridPanel.reoptPreviewData.mdReopt, gridPanel.reoptPreviewData);
    }
    if (reoptPreviewDataUtilsService.isNdReoptPreview(gridPanel.reoptPreviewData)) {
      flightAnalysisGridService.updateReoptPreviewRows(gridPanel.gridId, gridPanel.jqxGridSettings, gridPanel.reoptPreviewData.ndReopt);
    }
  }
  $scope.getReoptimizedMarket = function () {
    if (reoptPreviewDataUtilsService.isMdReopt(gridPanel.reoptPreviewData)) {
      gridPanel.reoptPreviewData.mdReopt.read = true;
      $scope.isReoptimizeButtonShown = false;
      $scope.data.dateReopt = 'reoptPreview';
      updateReoptPreviewRows();
    }
    angular.element('.toolbar-dropdown-menu').parent().removeClass('open');
  };
  $scope.cancelCheckStatusInterval = function () {
    if (checkStatusInterval) {
      $interval.cancel(checkStatusInterval);
    }
  };
  $scope.$on('$destroy', $scope.cancelCheckStatusInterval);
  $scope.$watch('gridPanelScope.gridDataLoaded', function (newVal, oldVal) {
    if ((gridPanel.reoptPreviewData.mdReopt || gridPanel.reoptPreviewData.ndReopt) && newVal === true && oldVal === false) {
      updateReoptPreviewRows();
    }
  });
  $scope.areRowsSelectedAndMdReoptSubmitted = function () {
    return $scope.hasRows && $scope.isMdReoptSubmitted();
  };
};
GridDateReoptPreviewButtonController.$inject = ['$scope', '$interval', '$rootScope', 'FeatureToggleService', 'ScenarioService', 'ReoptimizationService', 'ReoptimizationSaveService', 'MarketAnalysisGridService', 'FlightAnalysisGridService', 'ReoptPreviewDataUtilsService', 'SaveButtonUtilsService'];
module.exports = GridDateReoptPreviewButtonController;